import {SyncTime} from '../../interfaces/core/sync-time';
import {TableName} from '../../enums/core/table-name';
import {DateTime} from 'luxon';


export class SyncTimeFactory {
  public static new(tableName: TableName): SyncTime {
    return {
      id: undefined,
      time: DateTime.local().toISO(),
      tableName: tableName
    };
  }
}
